// extracted by mini-css-extract-plugin
export var locationsContainer = "_zs-2";
export var locationsTextContainer = "_zs-1";
export var mapContainer = "_zs-0";